import React, { ReactNode, JSX } from "react";

import UserProvider from "./components/userProvider";
import AppProvider from "./components/appProvider";

// MAIN COMPONENT

type ProviderProps = {
  LoginForm: React.ComponentType<any>;
  children: ReactNode;
};

const Provider = ({ LoginForm, children }: ProviderProps): JSX.Element => {
  return (
    <UserProvider LoginForm={LoginForm}>
      <AppProvider>{children}</AppProvider>
    </UserProvider>
  );
};

export default Provider;
